import React from "react";
import {
  MDBFooter,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBIcon,
} from "mdb-react-ui-kit";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <MDBFooter
      style={{ backgroundColor: "#046307" }}
      className="text-center text-lg-start text-white p-2"
    >
      <section className="">
        <MDBContainer className="text-center text-md-start mt-5">
          <MDBRow className="mt-3">
            <MDBCol md="3" lg="4" xl="3" className="mx-auto mb-4">
              <img src="Images/nav.png" style={{ width: "300px" }} alt="logo" />
              <br />
              <p>Affordable fashion choices...</p>
            </MDBCol>

            <MDBCol md="2" lg="2" xl="2" className="mx-auto mb-4">
              <h6 className="text-uppercase fw-bold mb-4">Products</h6>
              <p>
                <Link to="category/hand_bags" className="text-reset">
                  Hand bags
                </Link>
              </p>
              <p>
                <Link to="category/purses" className="text-reset">
                  Purses
                </Link>
              </p>
              <p>
                <Link to="category/jewelry" className="text-reset">
                  Jewelry
                </Link>
              </p>
              <p>
                <Link to="category/shoes" className="text-reset">
                  Shoes
                </Link>
              </p>
              <p>
                <Link to="category/used_bag_packs" className="text-reset">
                  Used bag packs
                </Link>
              </p>
            </MDBCol>

            <MDBCol md="3" lg="2" xl="2" className="mx-auto mb-4">
              <h6 className="text-uppercase fw-bold mb-4">Useful links</h6>
              <p>
                <a href="#!" className="text-reset">
                  Home
                </a>
              </p>
              <p>
                <a href="#!" className="text-reset">
                  Contact Us
                </a>
              </p>
            </MDBCol>

            <MDBCol md="4" lg="3" xl="3" className="mx-auto mb-md-0 mb-4">
              <h6 className="text-uppercase fw-bold mb-4">Contact</h6>
              <p>
                <MDBIcon icon="home" className="me-2" />
                Ham Shopping Mall, G347
              </p>
              <p>
                <MDBIcon icon="envelope" className="me-3" />
                frenianamatovu353@gmail.com
              </p>
              <p>
                <MDBIcon icon="phone" className="me-3" /> +256 784 865480
              </p>
              <p>
                <MDBIcon icon="print" className="me-3" /> +256 700 740227
              </p>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </section>
    </MDBFooter>
  );
}
